
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3437",
  depVersions: {
  "customer-portal-app": "static-1.3437",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.2968",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10123",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26521",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6075",
  "hs-test-utils": "static-1.8521",
  "hub-http": "static-1.6689",
  "hub-http-shared-msw-handlers": "static-1.10920",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19299",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11970",
  "I18n": "static-7.1709",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6935",
  "payment-link-components": "static-1.24473",
  "portals-platform-bend-plugin": "static-1.27",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7667",
  "quartz-core": "static-1.6886",
  "quartz-i18n": "static-1.1342",
  "react": "static-7.203",
  "react-colorpicker": "static-2.10692",
  "react-dlb": "static-1.94",
  "react-utils": "static-2.5661",
  "reselect": "static-3.16",
  "rich-text-lib": "static-1.20568",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18549",
  "ui-components-test-utils": "static-1.6107",
  "UIComponents": "static-3.8916",
  "video-player-core": "static-1.21",
  "foundations-assets": "static-1.5370",
  "foundations-components": "static-1.8763",
  "foundations-theming": "static-1.4972",
  "foundations-theming-specialty": "static-1.2688",
  "framer-motion": "static-1.84",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1705",
  "quartz-config": "static-1.1445",
  "quartz-routing": "static-1.1097",
  "quick-fetch": "static-1.4236",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17220",
  "rpc-client-utils": "static-1.5152",
  "sanitize-text": "static-1.8641",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.66",
  "ui-addon-draggable": "static-3.5231",
  "ui-addon-react-router-dom": "static-1.10007",
  "usage-tracker": "static-1.7807",
  "usage-tracker-anonymous": "static-1.6224",
  "usage-tracker-core": "static-1.7657",
  "video-components-external": "static-1.12449",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3944",
  "quartz-webpack": "static-1.3891",
  "bend-plugin-quartz-routing": "static-1.745",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4980",
  "icons": "static-2.703",
  "StyleGuideUI": "static-3.518",
  "trellis-components": "static-1.3125",
  "trellis-migration-context": "static-1.63",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "customer-data-objects": "static-1.8188",
  "frontend-preferences-client": "static-1.8403",
  "laboratory-lib": "static-3.7629",
  "onboarding-scopes": "static-1.6935",
  "seat-types-lib": "static-1.1069",
  "ui-addon-opt": "static-4.8894",
  "HeadJS": "static-2.823",
  "hs-test-utils-bend-plugin": "static-1.3632",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.405",
  "ts-schema": "static-1.4399",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8434",
  "content-media-capture": "static-1.5817",
  "cssUtils": "static-1.1105",
  "customer-data-ui-utilities": "static-1.10314",
  "file-manager-components": "static-1.24861",
  "HubStyle": "static-2.12277",
  "knowledge-content-types": "static-1.8763",
  "PatternValidationJS": "static-1.3366",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10346",
  "ui-addon-i18n": "static-1.11628",
  "ui-business-units-lib": "static-1.9578",
  "ui-shepherd-react": "static-3.10761",
  "video-data-lib": "static-1.36107",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4790",
  "commerce-tours-lib": "static-1.6876",
  "customer-data-properties": "static-1.53072",
  "getting-started-shared-tasks": "static-1.19583",
  "growth-onboarding-reliability": "static-1.5566",
  "onboarding-tours": "static-1.17410",
  "reference-resolvers-lite": "static-1.8595",
  "sales-checkout-service-client": "static-1.4002",
  "ui-addon-iframeable": "static-1.9558",
  "user-context": "static-1.5536",
  "bender-build-tools": "static-1.3600",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.649",
  "quartz-auth": "static-1.1342",
  "quartz-head": "static-1.1332",
  "quartz-test": "static-1.1342",
  "quartz-tracking": "static-1.1046",
  "ui-fonts": "static-1.1232",
  "usage-tracker-container": "static-1.7797",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9910",
  "data-token-picker": "static-1.17148",
  "FileManagerLib": "static-1.40501",
  "property-translator": "static-1.5862",
  "merchandise-lib": "static-1.286",
  "purchase-motions-components": "static-1.6642",
  "SharedI18nStrings": "static-1.188",
  "foundations-components-test-utils": "static-1.6246",
  "react-create-root-preference": "static-1.104",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "ui-images": "static-2.1277",
  "bend-plugin-foundations-components": "static-1.5032",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "trellis-assets": "static-1.3106",
  "bend-plugin-foundations-theming": "static-1.3455",
  "foundations-theming-base": "static-1.3957",
  "stylex": "static-1.46",
  "interframe": "static-3.5224",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6221",
  "opentelemetry-fe-types": "static-1.274",
  "beacon-keepalive-queue": "static-1.183",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.562",
  "chirp-fetch": "static-1.2387",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4957",
  "react-flip-move": "static-1.83",
  "apollo-link-hub-http": "static-2.5070",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "idb-keyval": "static-1.55",
  "immer": "static-1.105",
  "immerable": "static-1.4624",
  "magpie-lib": "static-1.5913",
  "magpie-types": "static-1.5373",
  "media-bridge-lib": "static-1.19655",
  "sassPrefix": "static-1.371",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "trellis-theming": "static-1.1492",
  "tanstack-virtual": "static-1.43",
  "inbound-db-properties-service-client": "static-1.4156",
  "superstore": "static-1.5242",
  "feedback-loader": "static-1.30075",
  "ai-components-ui-library": "static-1.10039",
  "ui-addon-video-player": "static-1.9106",
  "ui-coaching-tips": "static-1.29591",
  "ContentUtils": "static-1.69494",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4910",
  "react-dnd-compat": "static-1.5092",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2216",
  "copilot-toolkit": "static-1.12166",
  "poll-commands": "static-1.3960",
  "atom": "static-1.5555",
  "navigation-messaging": "static-1.8512",
  "redux-thunk": "static-2.84",
  "reference-resolvers": "static-1.8666",
  "commerce-products-lib": "static-1.10938",
  "crm-message-bus": "static-1.44128",
  "growth-data-modal": "static-1.6146",
  "hubspot-apollo-client": "static-1.5365",
  "onboarding-tours-client": "static-1.5625",
  "batch-promise": "static-1.2031",
  "calling-global-api": "static-1.66218",
  "calling-internal-common": "static-1.31808",
  "calling-lifecycle-internal": "static-1.67600",
  "calling-lifecycle-messages": "static-1.59892",
  "conditional-properties-service-client": "static-1.4118",
  "crm-index-visualization-core": "static-1.4768",
  "crm-links": "static-1.6796",
  "crm-pipelines-api-client-types": "static-1.4448",
  "customer-data-objects-ui-components": "static-1.13518",
  "customer-data-properties-shared-msw-handlers": "static-1.10247",
  "customer-data-property-utils": "static-1.8533",
  "external-options-client-types": "static-1.4444",
  "formula-editor": "static-1.15022",
  "google-libphonenumber": "static-1.49",
  "hs-resources": "static-1.669",
  "inbound-db-meta-service-client": "static-1.3779",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1114",
  "multi-currency-client-types": "static-1.4012",
  "object-builder-ui-client": "static-1.50069",
  "pipeline-validation-client-types": "static-1.4287",
  "property-value-citations": "static-1.3686",
  "pulse": "static-1.1132",
  "smart-data-capture-core": "static-1.492",
  "smart-property-lib": "static-1.8677",
  "tiered-pricing": "static-1.2297",
  "topics-actions-lib": "static-1.665",
  "trellis-ext-i18n": "static-1.1402",
  "trial-components-library": "static-1.14392",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "growth-onboarding-confetti": "static-1.3541",
  "growth-onboarding-next-action-utils": "static-1.3001",
  "navigation-components": "static-1.19185",
  "nest": "static-1.718",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-tracker": "static-1.8142",
  "ui-universal-auth": "static-1.9761",
  "getting-started-shared-tasks-store": "static-1.18701",
  "opentelemetry-web": "static-1.23",
  "hubspotter-http-shared-msw-handlers": "static-1.10918",
  "usage-tracker-session-replay": "static-1.5493",
  "audio-components": "static-1.6584",
  "FileManagerCore": "static-1.40360",
  "FileManagerImages": "static-1.38012",
  "video-components": "static-1.14451",
  "foundations-components-legacy": "static-1.1788",
  "purchase-motions-api": "static-1.6645",
  "signup-constants": "static-1.19957",
  "signup-ui-url-generator": "static-2.8520",
  "stylex-utils": "static-1.176",
  "usage-tracker-public": "static-1.7618",
  "reactive-lib": "static-1.1202",
  "simple-logging-lib": "static-1.3534",
  "nudge-client-utils": "static-1.3436",
  "chatspot-core": "static-1.23930",
  "growth-onboarding-feedback-components": "static-1.7063",
  "cms-field-types": "static-1.5293",
  "content-icons-ui": "static-1.2464",
  "integrations-lib": "static-1.17447",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1194",
  "breeze-engine-core": "static-1.1494",
  "highlight.js": "static-1.90",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30822",
  "commerce-permissions": "static-1.1267",
  "customer-data-tracking": "static-1.7353",
  "products-iframe-lib": "static-1.8934",
  "products-ui-components-shared-msw-handlers": "static-1.11302",
  "restore-request-side-panel-lib": "static-1.2042",
  "onboarding-data-sync-lib": "static-1.2852",
  "hubspot-apollo-cache": "static-1.824",
  "calling-error-reporting": "static-1.31815",
  "shared-worker-versioning": "static-1.11526",
  "calling-usage-tracker": "static-1.7022",
  "conversations-skeleton-state": "static-1.7608",
  "voice-sms-access-library": "static-1.2478",
  "crm-index-associations-lib": "static-1.6931",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11003",
  "redux-toolkit": "static-1.82",
  "sales-views-client-types": "static-1.4740",
  "framework-data-schema-resolvers": "static-1.7375",
  "location-customization-utils-lib": "static-1.10440",
  "bark-lib": "static-1.17014",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6378",
  "react-codemirror": "static-1.11124",
  "event-emitter": "static-1.1444",
  "fdsr-migration-layer": "static-1.494",
  "framework-builder-read-service-client": "static-1.4340",
  "bend-plugin-pulse": "static-1.635",
  "fast-json-patch": "static-1.74",
  "data-agent-kit": "static-1.932",
  "data-agent-test-utils": "static-1.476",
  "data-agent-utils": "static-1.945",
  "fsm": "static-1.4240",
  "policy-lib": "static-1.7287",
  "react-tinymce": "static-1.56285",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11066",
  "tinymce-config": "static-2.55411",
  "tinymce-plugins": "static-1.58525",
  "embedded-academy-lib": "static-1.16031",
  "hubs-service-types": "static-1.1751",
  "salesImages": "static-1.740",
  "growth-onboarding-next-action-components": "static-1.3029",
  "user-context-client": "static-1.4992",
  "custom-vendor-connection-lib": "static-1.325",
  "unified-auth-core-lib": "static-1.1557",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.997",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4997",
  "video-embed": "static-1.36941",
  "social-insights-client-types": "static-1.22947",
  "nudge-custom-function-registry": "static-1.3193",
  "nudge-renderer-utils": "static-1.3512",
  "whisper-core-api": "static-1.7653",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14862",
  "integrations-tracking-lib": "static-1.6103",
  "native-integrations-shared-strings": "static-1.8246",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10853",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15859",
  "meetings-connect-utils-lib": "static-1.8101",
  "calling-orchestration-schema": "static-1.37255",
  "framework-data-schema-quick-fetch": "static-1.7280",
  "persist-promise": "static-1.4188",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16685",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "trellis-story-utils": "static-1.4981",
  "enrichment-settings-lib": "static-1.250",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57381",
  "hub-http-contrib": "static-1.3515",
  "tinymce-data": "static-1.41496",
  "ui-addon-sales-email": "static-1.5684",
  "layout-dnd-components": "static-1.13242",
  "layout-dnd-utils": "static-1.12217",
  "ui-brand-identity-lib": "static-1.16970",
  "academy-common-lib": "static-1.15492",
  "outpost": "static-1.4610",
  "universal-page-editor-lib": "static-1.3495",
  "NamespacedHubStyle": "static-2.9372",
  "ContentData": "static-1.69569",
  "layout-data-lib": "static-1.10542",
  "academy-service-client": "static-1.4175",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4879",
  "trellis-ecosystem": "static-1.7863",
  "wootric-nps": "static-1.7301",
  "crm-record-cards-client": "static-1.76",
  "advanced-menus-core": "static-1.15829",
  "advanced-menus-lib": "static-1.12578",
  "ExportDialog": "static-6.10856",
  "ui-memberships-settings-lib": "static-1.35217",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15828",
  "simple-menus-lib": "static-1.17345",
  "settings-ui-lib": "static-1.13010",
  "developer-experience-shared-components": "static-1.11022",
  "immutable-less": "static-1.5135",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8436",
  "ui-extensibility-client-types": "static-1.4398",
  "ai-settings-ui-library": "static-1.8605",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1601",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4620",
  "simple-data-table": "static-1.3839"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3437",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.2968",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10123",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26521",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6075",
  "hs-test-utils": "/hs-test-utils/static-1.8521",
  "hub-http": "/hub-http/static-1.6689",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10920",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19299",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11970",
  "I18n": "/I18n/static-7.1709",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6935",
  "payment-link-components": "/payment-link-components/static-1.24473",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.27",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7667",
  "quartz-core": "/quartz-core/static-1.6886",
  "quartz-i18n": "/quartz-i18n/static-1.1342",
  "react": "/react/static-7.203",
  "react-colorpicker": "/react-colorpicker/static-2.10692",
  "react-dlb": "/react-dlb/static-1.94",
  "react-utils": "/react-utils/static-2.5661",
  "reselect": "/reselect/static-3.16",
  "rich-text-lib": "/rich-text-lib/static-1.20568",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18549",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6107",
  "UIComponents": "/UIComponents/static-3.8916",
  "video-player-core": "/video-player-core/static-1.21",
  "foundations-assets": "/foundations-assets/static-1.5370",
  "foundations-components": "/foundations-components/static-1.8763",
  "foundations-theming": "/foundations-theming/static-1.4972",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2688",
  "framer-motion": "/framer-motion/static-1.84",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1705",
  "quartz-config": "/quartz-config/static-1.1445",
  "quartz-routing": "/quartz-routing/static-1.1097",
  "quick-fetch": "/quick-fetch/static-1.4236",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17220",
  "rpc-client-utils": "/rpc-client-utils/static-1.5152",
  "sanitize-text": "/sanitize-text/static-1.8641",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.66",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5231",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10007",
  "usage-tracker": "/usage-tracker/static-1.7807",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6224",
  "usage-tracker-core": "/usage-tracker-core/static-1.7657",
  "video-components-external": "/video-components-external/static-1.12449",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3944",
  "quartz-webpack": "/quartz-webpack/static-1.3891",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.745",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4980",
  "icons": "/icons/static-2.703",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "trellis-components": "/trellis-components/static-1.3125",
  "trellis-migration-context": "/trellis-migration-context/static-1.63",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "customer-data-objects": "/customer-data-objects/static-1.8188",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8403",
  "laboratory-lib": "/laboratory-lib/static-3.7629",
  "onboarding-scopes": "/onboarding-scopes/static-1.6935",
  "seat-types-lib": "/seat-types-lib/static-1.1069",
  "ui-addon-opt": "/ui-addon-opt/static-4.8894",
  "HeadJS": "/HeadJS/static-2.823",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3632",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.405",
  "ts-schema": "/ts-schema/static-1.4399",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8434",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "cssUtils": "/cssUtils/static-1.1105",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10314",
  "file-manager-components": "/file-manager-components/static-1.24861",
  "HubStyle": "/HubStyle/static-2.12277",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "PatternValidationJS": "/PatternValidationJS/static-1.3366",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10346",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11628",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9578",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10761",
  "video-data-lib": "/video-data-lib/static-1.36107",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4790",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6876",
  "customer-data-properties": "/customer-data-properties/static-1.53072",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19583",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5566",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8595",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4002",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9558",
  "user-context": "/user-context/static-1.5536",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.649",
  "quartz-auth": "/quartz-auth/static-1.1342",
  "quartz-head": "/quartz-head/static-1.1332",
  "quartz-test": "/quartz-test/static-1.1342",
  "quartz-tracking": "/quartz-tracking/static-1.1046",
  "ui-fonts": "/ui-fonts/static-1.1232",
  "usage-tracker-container": "/usage-tracker-container/static-1.7797",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9910",
  "data-token-picker": "/data-token-picker/static-1.17148",
  "FileManagerLib": "/FileManagerLib/static-1.40501",
  "property-translator": "/property-translator/static-1.5862",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "purchase-motions-components": "/purchase-motions-components/static-1.6642",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6246",
  "react-create-root-preference": "/react-create-root-preference/static-1.104",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "ui-images": "/ui-images/static-2.1277",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5032",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "trellis-assets": "/trellis-assets/static-1.3106",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3455",
  "foundations-theming-base": "/foundations-theming-base/static-1.3957",
  "stylex": "/stylex/static-1.46",
  "interframe": "/interframe/static-3.5224",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6221",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.274",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.183",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.562",
  "chirp-fetch": "/chirp-fetch/static-1.2387",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4957",
  "react-flip-move": "/react-flip-move/static-1.83",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5070",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "idb-keyval": "/idb-keyval/static-1.55",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4624",
  "magpie-lib": "/magpie-lib/static-1.5913",
  "magpie-types": "/magpie-types/static-1.5373",
  "media-bridge-lib": "/media-bridge-lib/static-1.19655",
  "sassPrefix": "/sassPrefix/static-1.371",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "trellis-theming": "/trellis-theming/static-1.1492",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4156",
  "superstore": "/superstore/static-1.5242",
  "feedback-loader": "/feedback-loader/static-1.30075",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10039",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9106",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29591",
  "ContentUtils": "/ContentUtils/static-1.69494",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4910",
  "react-dnd-compat": "/react-dnd-compat/static-1.5092",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2216",
  "copilot-toolkit": "/copilot-toolkit/static-1.12166",
  "poll-commands": "/poll-commands/static-1.3960",
  "atom": "/atom/static-1.5555",
  "navigation-messaging": "/navigation-messaging/static-1.8512",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reference-resolvers": "/reference-resolvers/static-1.8666",
  "commerce-products-lib": "/commerce-products-lib/static-1.10938",
  "crm-message-bus": "/crm-message-bus/static-1.44128",
  "growth-data-modal": "/growth-data-modal/static-1.6146",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5365",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "batch-promise": "/batch-promise/static-1.2031",
  "calling-global-api": "/calling-global-api/static-1.66218",
  "calling-internal-common": "/calling-internal-common/static-1.31808",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67600",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59892",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4118",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4768",
  "crm-links": "/crm-links/static-1.6796",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4448",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13518",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10247",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8533",
  "external-options-client-types": "/external-options-client-types/static-1.4444",
  "formula-editor": "/formula-editor/static-1.15022",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "hs-resources": "/hs-resources/static-1.669",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3779",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1114",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4012",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50069",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4287",
  "property-value-citations": "/property-value-citations/static-1.3686",
  "pulse": "/pulse/static-1.1132",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.492",
  "smart-property-lib": "/smart-property-lib/static-1.8677",
  "tiered-pricing": "/tiered-pricing/static-1.2297",
  "topics-actions-lib": "/topics-actions-lib/static-1.665",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1402",
  "trial-components-library": "/trial-components-library/static-1.14392",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3541",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3001",
  "navigation-components": "/navigation-components/static-1.19185",
  "nest": "/nest/static-1.718",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8142",
  "ui-universal-auth": "/ui-universal-auth/static-1.9761",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18701",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10918",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5493",
  "audio-components": "/audio-components/static-1.6584",
  "FileManagerCore": "/FileManagerCore/static-1.40360",
  "FileManagerImages": "/FileManagerImages/static-1.38012",
  "video-components": "/video-components/static-1.14451",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1788",
  "purchase-motions-api": "/purchase-motions-api/static-1.6645",
  "signup-constants": "/signup-constants/static-1.19957",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "stylex-utils": "/stylex-utils/static-1.176",
  "usage-tracker-public": "/usage-tracker-public/static-1.7618",
  "reactive-lib": "/reactive-lib/static-1.1202",
  "simple-logging-lib": "/simple-logging-lib/static-1.3534",
  "nudge-client-utils": "/nudge-client-utils/static-1.3436",
  "chatspot-core": "/chatspot-core/static-1.23930",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7063",
  "cms-field-types": "/cms-field-types/static-1.5293",
  "content-icons-ui": "/content-icons-ui/static-1.2464",
  "integrations-lib": "/integrations-lib/static-1.17447",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1194",
  "breeze-engine-core": "/breeze-engine-core/static-1.1494",
  "highlight.js": "/highlight.js/static-1.90",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30822",
  "commerce-permissions": "/commerce-permissions/static-1.1267",
  "customer-data-tracking": "/customer-data-tracking/static-1.7353",
  "products-iframe-lib": "/products-iframe-lib/static-1.8934",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11302",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2042",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2852",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.824",
  "calling-error-reporting": "/calling-error-reporting/static-1.31815",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11526",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7022",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2478",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6931",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11003",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "sales-views-client-types": "/sales-views-client-types/static-1.4740",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7375",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10440",
  "bark-lib": "/bark-lib/static-1.17014",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6378",
  "react-codemirror": "/react-codemirror/static-1.11124",
  "event-emitter": "/event-emitter/static-1.1444",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.494",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4340",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.635",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "data-agent-kit": "/data-agent-kit/static-1.932",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.476",
  "data-agent-utils": "/data-agent-utils/static-1.945",
  "fsm": "/fsm/static-1.4240",
  "policy-lib": "/policy-lib/static-1.7287",
  "react-tinymce": "/react-tinymce/static-1.56285",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11066",
  "tinymce-config": "/tinymce-config/static-2.55411",
  "tinymce-plugins": "/tinymce-plugins/static-1.58525",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16031",
  "hubs-service-types": "/hubs-service-types/static-1.1751",
  "salesImages": "/salesImages/static-1.740",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3029",
  "user-context-client": "/user-context-client/static-1.4992",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.325",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1557",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.997",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4997",
  "video-embed": "/video-embed/static-1.36941",
  "social-insights-client-types": "/social-insights-client-types/static-1.22947",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3193",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3512",
  "whisper-core-api": "/whisper-core-api/static-1.7653",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14862",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6103",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8246",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10853",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15859",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8101",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37255",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7280",
  "persist-promise": "/persist-promise/static-1.4188",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16685",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "trellis-story-utils": "/trellis-story-utils/static-1.4981",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.250",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57381",
  "hub-http-contrib": "/hub-http-contrib/static-1.3515",
  "tinymce-data": "/tinymce-data/static-1.41496",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5684",
  "layout-dnd-components": "/layout-dnd-components/static-1.13242",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12217",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16970",
  "academy-common-lib": "/academy-common-lib/static-1.15492",
  "outpost": "/outpost/static-1.4610",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3495",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9372",
  "ContentData": "/ContentData/static-1.69569",
  "layout-data-lib": "/layout-data-lib/static-1.10542",
  "academy-service-client": "/academy-service-client/static-1.4175",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4879",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7863",
  "wootric-nps": "/wootric-nps/static-1.7301",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.76",
  "advanced-menus-core": "/advanced-menus-core/static-1.15829",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12578",
  "ExportDialog": "/ExportDialog/static-6.10856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35217",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15828",
  "simple-menus-lib": "/simple-menus-lib/static-1.17345",
  "settings-ui-lib": "/settings-ui-lib/static-1.13010",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11022",
  "immutable-less": "/immutable-less/static-1.5135",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8436",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4398",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8605",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1601",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4620",
  "simple-data-table": "/simple-data-table/static-1.3839"
}
};
